import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6fd2be7a&"
import script from "./index.vue?vue&type=script&lang=coffee&"
export * from "./index.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports